<div class="l-paging-search">
  <h3 class="c-paging-search-title">{{ label }}</h3>
  <ul class="c-paging-search-list">
    <ng-content></ng-content>
  </ul>
</div>
